import { useAuthStore } from '@core/stores/auth'

// Navigation guard for authentication. Pages opt in with definePageMeta({ requiresAuth: true }).
export default defineNuxtRouteMiddleware((to) => {
    // The session (tokens in localStorage) only exists in the browser; the pages that need it
    // are rendered there (routeRules ssr: false in nuxt.config.ts).
    if (import.meta.server) return

    const authStore = useAuthStore()

    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
        return navigateTo({ name: 'Login', query: { redirect: to.fullPath } })
    }

    if (to.name === 'Login' && authStore.isAuthenticated) {
        return navigateTo({ name: 'Home' })
    }
})
